import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@emotion/react';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import { Row, Col, Container } from '@paypalcorp/pp-react-grid';
import { LoadingSpinner } from '@paypalcorp/pp-react-loading-spinner';
import { CaptionText, BodyText, HeadingText } from '@paypalcorp/pp-react-text';
import { Alert } from '@paypalcorp/pp-react-alert';
import { Tooltip } from '@paypalcorp/pp-react-tooltip';
import { TextInput } from '@paypalcorp/pp-react-text-input';
import { DropdownMenu } from '@paypalcorp/pp-react-dropdown-menu';
import { Button } from '@paypalcorp/pp-react-buttons';
import { Card } from '@paypalcorp/pp-react-card';
import '../__generated__/styles/cc.css';

var FPTI_OBJECT = {
  page: PropTypes.string,
  pgrp: PropTypes.string
};
var APP_DATA_OBJECT = {
  countries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  formMapping: PropTypes.shape({}).isRequired,
  tTypeOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
var CC_DATA_OBJECT = {
  metaData: PropTypes.shape({}).isRequired,
  appData: PropTypes.shape(APP_DATA_OBJECT).isRequired,
  configs: PropTypes.shape({})
};
var CONVERSION_RESULT_OBJECT = {
  isLoaded: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  data: PropTypes.string.isRequired
};

var xhrRoutes = {
  META_DATA_URL: '/smarthelp/get-cc-meta',
  GET_CURRENCY_CONVERSION: '/smarthelp/currency-conversion'
};
var sizes$1 = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg'
};

/**
 *  method to validate is empty.
 * @param value
 * @returns {boolean}
 */
var isEmpty$1 = function (value) {
  return value === null || _typeof(value) === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};

/**
 *  Returns value from the content based on the key.
 * @param content
 * @param key
 * @returns {*}
 */
var getContentValue = function (content, key) {
  try {
    if (_typeof(content) === 'object' && !isEmpty$1(content)) {
      var path = key.split('.');
      while (path.length && (content = content[path.shift()]));
      return content;
    }
    return '';
  } catch (e) {
    return '';
  }
};

/**
 *  Function to form initial state data contract object for conversion form.
 * @param data
 * @returns {[]}
 */
var getInitialFormState = function (data) {
  var initialState = [];
  var formMappings = data && data.appData && data.appData.formMapping || null;
  if (!isEmpty$1(formMappings)) {
    var entries = Object.entries(formMappings);
    entries.forEach(function (entry) {
      initialState.push(entry[1]);
    });
    return initialState;
  }
  return initialState;
};
var setInnerContent = function (content) {
  return {
    __html: content
  };
};
var getCurrencyConversionResultUrl = function (formData, componentName) {
  var params = '';
  formData.forEach(function (field) {
    params = params.concat("".concat(field.name, "=").concat(field.value, "&"));
  });

  // append component name to the query params
  params = params.concat("component=".concat(componentName));

  // if (window.location.href === 'http://localhost:9000/') {
  // return `http://localhost.paypal.com:8081/smarthelp/currency-conversion?${params}`
  // }
  return xhrRoutes.GET_CURRENCY_CONVERSION + "?".concat(params);
};

/**
 *  Initial data model/meta service - To validate if the service response data has all the required data.
 * @param data
 * @returns {boolean}
 */
var validateDataModelServiceResponse = function (data) {
  return isEmpty$1(data.metaData) || isEmpty$1(data.appData) || isEmpty$1(data.appData.countries) || isEmpty$1(data.appData.currencies) || isEmpty$1(data.appData.formMapping) || isEmpty$1(data.appData.tTypeOptions);
};

var sizes = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg'
};
var spinnerTypes = {
  SHIMMER: 'shimmer',
  LOADER: 'loader'
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      error: null,
      errorInfo: null
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(err, errorInfo) {
      this.setState({
        err: err,
        errorInfo: errorInfo
      });
      if (typeof this.props.cbOnError === 'function') {
        // Callback function to track errors.
        this.props.cbOnError(err, errorInfo);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.error) {
        // render any custom fallback UI
        return this.props.children;
      }
      if (this.props.suppressError) {
        return /*#__PURE__*/React.createElement("div", null);
      }
      return /*#__PURE__*/React.createElement("h1", null, 'Something went wrong in loading the widget.');
    }
  }]);
  return ErrorBoundary;
}(React.Component);
ErrorBoundary.propTypes = {
  suppressError: PropTypes.bool.isRequired,
  children: PropTypes.node,
  cbOnError: PropTypes.func.isRequired // callback function on error.
};

// //https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/onreadystatechange
var getData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var config,
      method,
      req,
      response,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          method = config.method || 'GET';
          _context.prev = 2;
          req = new XMLHttpRequest();
          req.open(method, url, true);
          req.withCredentials = config.withCredentials || false;
          _context.next = 8;
          return new Promise(function (resolve, reject) {
            req.onreadystatechange = function () {
              if (req.readyState === 4) {
                if (req.status >= 200 && req.status < 300) {
                  var result = JSON.parse(req.response || req.responseText);
                  resolve(result);
                } else {
                  reject("HTTP Error: ".concat(req.status));
                }
              }
            };
            req.addEventListener('error', function (event) {
              reject(event);
            });
            req.send();
          });
        case 8:
          response = _context.sent;
          return _context.abrupt("return", {
            data: response
          });
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 12]]);
  }));
  return function () {
    return _ref.apply(this, arguments);
  };
}();

/**
 *  method to validate is empty.
 * @param value
 * @returns {boolean}
 */
var isEmpty = function (value) {
  return value === null || _typeof(value) === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};

/**
 * Deep clone to remove the reference of the object.
 * @param data
 * @returns {*}
 */
var deepClone = function (data) {
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (e) {
    return data;
  }
};

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultOptions = {
  pgrp: 'main:help:components',
  page: 'main:help:components',
  comp: 'helpComponents'
};
var analyticsObject = function () {
  try {
    return window && window.PAYPAL && window.PAYPAL.analytics;
  } catch (e) {
    return {};
  }
};

// Get FPTI otions
var getFPTIOptions = function (fptiOptions, eventType) {
  var fpti = window && window.fpti ? deepClone(window.fpti) : {};

  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // Merge client passed fptiOptions with fpti object.
  fpti = _objectSpread$2(_objectSpread$2({}, fpti), fptiOptions);

  // TODO :: This logic needs to be revisited.
  // FPTI options passed through props

  if (isEmpty(fpti.page) || isEmpty(fpti.pgrp)) {
    fpti.page = defaultOptions.page;
    fpti.pgrp = defaultOptions.pgrp;
  }

  // Resetting to empty string for not to set link/pgln,phlk for ac events.
  fpti.link = '';
  fpti.pgln = '';
  fpti.pglk = '';

  // For click events
  if (fptiOptions.link) {
    fpti.link = fptiOptions.link;
    fpti.pgln = "".concat(fpti.page, "|").concat(fptiOptions.link);
    fpti.pglk = "".concat(fpti.pgrp, "|").concat(fptiOptions.link);
  }

  // Add event name to FPTI object
  fpti.event_name = '';
  if (fptiOptions.event_name) {
    fpti.event_name = fptiOptions.event_name;
  }

  // component name priority - fpti options props/analytics window object/default fallback
  if (isEmpty(fpti.comp)) {
    fpti.comp = defaultOptions.comp;
  }
  // Set event Type
  fpti.e = eventType ? eventType : 'ac'; // default activity event

  return fpti;
};

/**
 * @description
 *
 * Logs click metrics
 * @param {Object} fptiOptions
 * @property {String} options.data.page - Page name if not provided derived from the base page
 * @property {String} options.data.pgrp - Page group if not provided derived from the base page
 * e.g. var options = {data: {page:'page_name', pgrp: 'page_group_name'} }
 */
//https://github.paypal.com/pages/Tracking-R/client-side-instrumentation/react.html#/links?_k=flh93g
var recordClickEvent = function (fptiOptions) {
  if (analyticsObject()) {
    var options = getFPTIOptions(fptiOptions, 'cl');
    window.PAYPAL.analytics.Analytics.prototype.recordClick({
      data: options
    });
  }
};

// Error tracking
// https://github.paypal.com/pages/Tracking-R/client-side-instrumentation/#record_error
var recordErrorEvent = function (error) {
  if (window.PAYPAL && window.PAYPAL.trackJSError) {
    window.PAYPAL.trackJSError(error);
  }
};

// Record Activity Events
var recordEvent = function (fptiOptions) {
  if (analyticsObject()) {
    var options = getFPTIOptions(fptiOptions, 'ac');
    window.PAYPAL.analytics.Analytics.prototype.recordEvent(options.event_name, {
      data: options
    });
  }
};
var getFptiOptionsPage = function (fptiOptionProps, componentName) {
  //FPTI options passed through props
  if (fptiOptionProps && Object.prototype.hasOwnProperty.call(fptiOptionProps, 'page')) {
    return fptiOptionProps.page;
  }

  // If no props where specified take page name from analytics data.
  var analytics = analyticsObject();
  if (analytics && analytics.options && analytics.options.data) {
    return analytics.options.data.page;
  }
  return componentName;
};
var getFptiOptionsPageGroup = function (fptiOptionProps, componentName) {
  //FPTI options passed through props
  if (fptiOptionProps && Object.prototype.hasOwnProperty.call(fptiOptionProps, 'pgrp')) {
    return fptiOptionProps.pgrp;
  }

  // If no props where specified take page group from analytics data.
  var analytics = analyticsObject();
  if (analytics && analytics.options && analytics.options.data) {
    return analytics.options.data.pgrp;
  }
  return componentName;
};

// FPTI Prop Type
({
  page: PropTypes.string.isRequired,
  pgrp: PropTypes.string.isRequired,
  comp: PropTypes.string
});

// Component bottom disclaimer text
var Disclaimer = function (props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "hc-currency-converter--disclaimer"
  }, /*#__PURE__*/React.createElement(CaptionText, {
    dangerouslySetInnerHTML: setInnerContent(getContentValue(props.metaData, 'bottomDisclaimer'))
  }));
};
Disclaimer.propTypes = {
  metaData: PropTypes.shape({}).isRequired
};

// Header subtext/intro label component
var ToolIntroLabel = function (props) {
  return /*#__PURE__*/React.createElement(BodyText, {
    dangerouslySetInnerHTML: setInnerContent(getContentValue(props.metaData, 'introLabel'))
  });
};
ToolIntroLabel.propTypes = {
  metaData: PropTypes.shape({}).isRequired
};

// Header text/label component
var Header = function (props) {
  return /*#__PURE__*/React.createElement(HeadingText, {
    size: "sm",
    dangerouslySetInnerHTML: setInnerContent(getContentValue(props.metaData, 'header'))
  });
};
Header.propTypes = {
  metaData: PropTypes.shape({}).isRequired
};

// Conversion result component to handle both success and error cases
var ConversionResult = function (props) {
  var _props$data = props.data,
    isLoaded = _props$data.isLoaded,
    isError = _props$data.isError,
    data = _props$data.data;

  // Success Case
  if (isLoaded && !isError) {
    return /*#__PURE__*/React.createElement(Row, {
      className: "hc-currency-converter--result"
    }, /*#__PURE__*/React.createElement(Col, {
      className: "hc-currency-converter--result_body"
    }, /*#__PURE__*/React.createElement(BodyText, {
      dangerouslySetInnerHTML: setInnerContent(data)
    })));
  }

  // Error Case
  if (isLoaded && isError) {
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Alert, {
      type: "error"
    }, data)));
  }
  return null;
};
ConversionResult.propTypes = {
  data: PropTypes.shape(CONVERSION_RESULT_OBJECT).isRequired
};

// Conversion form component
var ConversionForm = function (props) {
  var _props$data = props.data,
    metaData = _props$data.metaData,
    formMapping = _props$data.appData.formMapping,
    onChangeHandler = props.onChangeHandler,
    formData = props.formData;
  if (isEmpty$1(formMapping)) {
    return null;
  }

  // Render each field based on the field type
  var renderField = function (field) {
    var currentField = formData.find(function (formField) {
      return formField.name === field.name;
    });
    if (!currentField && _typeof(currentField) === 'object') {
      return null;
    }
    var label = !currentField.isRequired ? "".concat(currentField.label, " (").concat(getContentValue(metaData, 'optionalLabel'), ")") : currentField.label;
    switch (field.type) {
      case 'dropdown':
        {
          return /*#__PURE__*/React.createElement(DropdownMenu, {
            label: label,
            placeholder: currentField.placeholder,
            name: currentField.name,
            value: currentField.value,
            options: getContentValue(props.data, currentField.optionsPath),
            onChange: function onChange(e) {
              return onChangeHandler(e, currentField.name);
            },
            required: currentField.required,
            errorText: currentField.errorText,
            helperText: currentField.helperText
          });
        }
      case 'input':
      case 'text':
      case 'number':
        {
          return /*#__PURE__*/React.createElement(TextInput, {
            name: currentField.name,
            value: currentField.value,
            label: label,
            onChange: onChangeHandler,
            required: currentField.required,
            errorText: currentField.errorText,
            helperText: currentField.helperText
          });
        }
      case 'input_with_tooltip':
        {
          return /*#__PURE__*/React.createElement(TextInput, {
            name: currentField.name,
            value: currentField.value,
            label: label,
            onChange: onChangeHandler,
            required: currentField.required,
            errorText: currentField.errorText,
            helperText: currentField.helperText,
            rightIcon: /*#__PURE__*/React.createElement(Tooltip, {
              name: currentField.tooltip.name,
              description: currentField.tooltip.description,
              screenReaderText: currentField.tooltip.screenReaderText
            })
          });
        }
      default:
        return /*#__PURE__*/React.createElement("div", null);
    }
  };
  return /*#__PURE__*/React.createElement(Container, {
    form: true
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    form: "half"
  }, renderField(formMapping.fromCountry)), /*#__PURE__*/React.createElement(Col, {
    form: "half"
  }, renderField(formMapping.toCountry))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    form: "half"
  }, renderField(formMapping.fromPaymentCurrency)), /*#__PURE__*/React.createElement(Col, {
    form: "half"
  }, renderField(formMapping.toTransCurrency))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    form: "half"
  }, renderField(formMapping.tType)), /*#__PURE__*/React.createElement(Col, {
    form: "half"
  }, renderField(formMapping.transAmount))));
};
ConversionForm.propTypes = {
  data: PropTypes.shape(CC_DATA_OBJECT).isRequired,
  formData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChangeHandler: PropTypes.func.isRequired
};

// Submit button component
var SubmitBtn = function (props) {
  var _props$data = props.data,
    metaData = _props$data.metaData,
    formMapping = _props$data.appData.formMapping,
    onClickHandler = props.onClickHandler;
  if (isEmpty$1(formMapping)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return onClickHandler();
    }
  }, getContentValue(metaData, 'submitBtnLabel'))));
};
SubmitBtn.propTypes = {
  data: PropTypes.shape(CC_DATA_OBJECT).isRequired,
  onClickHandler: PropTypes.func.isRequired
};

// Check isEmpty form field validation
var isEmptyField = function (field, value) {
  return field.isRequired && !value;
};

/**
 *  This will check if field is required and value is empty then set error text message.
 * @param field
 * @param value
 * @param metaData
 * @returns {string|*}
 */
var checkForErrorMessage = function (field, value, metaData) {
  var errorText = '';
  if (field && _typeof(field) === 'object') {
    if (isEmptyField(field, value)) {
      errorText = metaData.reqValidationError;
      return errorText;
    }
  }
  return errorText;
};

/**
 *  Function to check if there any errors in the fields array.
 * @param formFields
 * @returns {boolean}
 */
var hasFormError = function (formFields) {
  if (!Array.isArray(formFields)) {
    return true;
  }
  var hasError = formFields.find(function (field) {
    return field.isRequired && !!field.errorText && !field.value;
  });
  return !!hasError;
};

/**
 *  Validate form data before submitting to the conversion service.
 * @param formFields
 * @param metaData
 * @returns {boolean|*}
 */
var validateFormData = function (formFields, metaData) {
  if (!Array.isArray(formFields)) {
    return true;
  }
  return formFields.map(function (field) {
    var errorText = checkForErrorMessage(field, field.value, metaData);
    return Object.assign({}, field, {
      errorText: errorText
    });
  });
};

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CurrencyConvWidget(props) {
  var data = props.data,
    componentName = props.componentName,
    fptiOptions = props.fptiOptions;
  var _useState = useState(getInitialFormState(data)),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var _useState3 = useState({
      isLoading: false,
      isLoaded: false,
      isError: false,
      data: ''
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    conversionResult = _useState4[0],
    setConversionResult = _useState4[1];

  // On actual component mount, Fire activity event.
  useEffect(function () {
    recordEvent(_objectSpread$1({
      comp: componentName,
      event_name: 'hc_currency_converter_widget_shown'
    }, fptiOptions));
  }, []);

  // On field input change handler
  var __onInputChangeHandler = function (e) {
    var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var _e$target = e.target,
      value = _e$target.value,
      name = _e$target.name;
    var updatedFields = formData.map(function (field) {
      if (field.name === name || field.name === fieldName) {
        return Object.assign({}, field, {
          value: value,
          errorText: checkForErrorMessage(field, value, data.metaData) // on input change check for validate for errors
        });
      }
      return field;
    });

    // Update state
    setFormData(updatedFields);
  };

  // Handle serivce catch block
  var conversionServiceCatchBlockHandler = function (e) {
    var statusCode = e.statusCode || e.err.statusCode;
    var updatedConversionResult = Object.assign({}, conversionResult, {
      // Take the error result from service response as first priority if not fallback to common error message.
      data: e.result || getContentValue(data.metaData, 'serviceFailureError'),
      isLoading: false,
      isLoaded: true,
      isError: true
    });
    setConversionResult(updatedConversionResult);

    // Track error with FPTI
    recordEvent(_objectSpread$1(_objectSpread$1({
      comp: componentName
    }, fptiOptions), {}, {
      link: "hc-currency-converter|conversion-service|error|status-code:".concat(statusCode),
      event_name: "hc_currency_conversion_service_error"
    }));
  };

  // On submit button handler
  var __onSubmitHandler = function () {
    // On click of submit button validate the fields with required has values
    var validatedFormData = validateFormData(formData, data.metaData);

    // Check for any form errors. If errors exists update the form state. If not move forward to service call.
    if (hasFormError(validatedFormData)) {
      return setFormData(validatedFormData);
    }

    // Before initializing service call set isLoading to true.
    setConversionResult(Object.assign({}, conversionResult, {
      isLoading: true
    }));

    // Fire FPTI click event
    var fptiClickEventOptions = _objectSpread$1({
      link: "hc-currency-converter|onClick|SubmitButton",
      comp: componentName
    }, fptiOptions);
    recordClickEvent(fptiClickEventOptions);

    // API call to get conversion result.
    return getData(getCurrencyConversionResultUrl(formData, componentName)).then(function (response) {
      var result = response.data.result;
      var updatedConversionResult = Object.assign({}, conversionResult, {
        data: result,
        isLoading: false,
        isLoaded: true,
        isError: false
      });
      setConversionResult(updatedConversionResult);

      //FPTI
      recordEvent(_objectSpread$1(_objectSpread$1({
        comp: componentName
      }, fptiOptions), {}, {
        link: 'hc-currency-converter|conversion-service|success',
        event_name: 'hc_currency_conversion_service_success'
      }));
    }).catch(function (e) {
      return conversionServiceCatchBlockHandler(e);
    });
  };

  // render submit button / loader based on the service loading
  var renderSubmitSlashLoader = function () {
    if (!conversionResult.isLoading) {
      return /*#__PURE__*/React.createElement(SubmitBtn, {
        data: data,
        onClickHandler: function onClickHandler() {
          return __onSubmitHandler();
        }
      });
    }
    return /*#__PURE__*/React.createElement(LoadingSpinner, {
      screenReaderText: "loading",
      size: sizes$1.SMALL
    });
  };
  return function renderConversionForm() {
    var metaData = data.metaData;
    return /*#__PURE__*/React.createElement(Container, {
      className: "hc-currency-converter"
    }, /*#__PURE__*/React.createElement(Header, {
      metaData: metaData
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ToolIntroLabel, {
      metaData: metaData
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ConversionForm, {
      data: data,
      formData: formData,
      onChangeHandler: __onInputChangeHandler
    }), /*#__PURE__*/React.createElement(ConversionResult, {
      data: conversionResult
    }), /*#__PURE__*/React.createElement(Row, {
      className: "hc-currency-converter--submit-btn"
    }, renderSubmitSlashLoader()), /*#__PURE__*/React.createElement(Disclaimer, {
      metaData: metaData
    }));
  }();
}
CurrencyConvWidget.propTypes = {
  data: PropTypes.shape(CC_DATA_OBJECT).isRequired,
  componentName: PropTypes.string,
  fptiOptions: PropTypes.shape(FPTI_OBJECT)
};

function Loader(props) {
  var spinnerType = props.spinnerType,
    spinnerSize = props.spinnerSize,
    customLoaderStyle = props.customLoaderStyle;
  return function renderLoader() {
    // Shimmer loader
    var customStyle;
    if (spinnerType === spinnerTypes.SHIMMER) {
      customStyle = customLoaderStyle || {
        height: '12rem',
        width: '100%'
      };
      return /*#__PURE__*/React.createElement("div", {
        style: customStyle
      }, /*#__PURE__*/React.createElement(Card, {
        isLoading: true
      }));
    }

    // Spinning loader

    customStyle = customLoaderStyle || {
      display: 'flex',
      justifyContent: 'center'
    };
    return /*#__PURE__*/React.createElement("div", {
      style: customStyle
    }, /*#__PURE__*/React.createElement(LoadingSpinner, {
      screenReaderText: "loading",
      size: spinnerSize
    }));
  }();
}

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getCurrencyConvMetaApiUrl = function (componentName) {
  return "/smarthelp/get-cc-meta?component=".concat(componentName);
  // return `http://localhost.paypal.com:8081/smarthelp/get-cc-meta?component=${componentName}`
};
function HcCurrencyConv(props) {
  var fptiOptions = props.fptiOptions,
    suppressError = props.suppressError,
    componentName = props.componentName,
    version = props.version,
    devMode = props.devMode,
    devData = props.devData,
    spinnerType = props.spinnerType,
    spinnerSize = props.spinnerSize,
    customLoaderStyle = props.customLoaderStyle;
  var _useState = useState({
      isLoading: true,
      isError: false,
      missingRequiredDataError: false,
      metaData: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];

  // Get initial config - metadata/form data.
  var initiateGetMetaData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, respData;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getData(getCurrencyConvMetaApiUrl(componentName));
          case 3:
            response = _context.sent;
            respData = response.data;
            setData({
              isLoading: false,
              isError: false,
              missingRequiredDataError: validateDataModelServiceResponse(respData),
              metaData: respData
            });
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            setData({
              isLoading: false,
              isError: true,
              missingRequiredDataError: false,
              metaData: null
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function () {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    // On dev mode get the dummy data which is passed through props
    if (devMode) {
      var timeoutId = setTimeout(function () {
        var isMissingRequiredData = validateDataModelServiceResponse(devData);
        setData({
          isLoading: false,
          isError: false,
          missingRequiredDataError: isMissingRequiredData,
          metaData: devData
        });
      }, 2000);
      return function () {
        return clearTimeout(timeoutId);
      };
    }
    return initiateGetMetaData();
  }, []);

  // Method to handle events on component error.
  // On component error fire impression event to track error cases.

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ErrorBoundary, {
    suppressError: suppressError,
    cbOnError: function handleErrorCatch(error) {
      var finalFPTIOptions = {
        page: getFptiOptionsPage(fptiOptions, componentName),
        pgrp: getFptiOptionsPageGroup(fptiOptions, componentName),
        event_name: 'hc_currency_converter_widget_loading_error'
      };
      recordErrorEvent(error);
      recordEvent(_objectSpread({
        comp: componentName
      }, finalFPTIOptions));
    }
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: PAYPAL_THEME
  }, function renderCurrencyConverter() {
    var isLoading = data.isLoading,
      isError = data.isError,
      missingRequiredDataError = data.missingRequiredDataError,
      metaData = data.metaData;

    // If data is not loaded yet. Return spinner/loader
    if (isLoading) {
      return (
        /*#__PURE__*/
        // <div className="hc-currency-converter--spinner">
        React.createElement(Loader, {
          spinnerType: spinnerType,
          spinnerSize: spinnerSize,
          customLoaderStyle: customLoaderStyle
        })
        // </div>
      );
    }

    // If has any error with XHR call. fire an FPTI.
    if (isError) {
      recordEvent(_objectSpread({
        comp: componentName,
        event_name: 'hc_currency_converter_meta_service_error'
      }, fptiOptions));
      return /*#__PURE__*/React.createElement("div", null);
    }

    // When service is success but if required data is missing from response then fire an FPTI and return empty div.
    if (missingRequiredDataError) {
      recordEvent(_objectSpread(_objectSpread({
        comp: componentName
      }, fptiOptions), {}, {
        link: 'hc-currency-converter|meta-service|required-fields-missing',
        event_name: 'hc_currency_converter_service_required_fields_missing'
      }));
      return /*#__PURE__*/React.createElement("div", null);
    }
    return /*#__PURE__*/React.createElement(CurrencyConvWidget, {
      version: version,
      data: metaData,
      componentName: componentName,
      fptiOptions: fptiOptions
    });
  }())));
}

// currency converter props
HcCurrencyConv.propTypes = {
  suppressError: PropTypes.bool,
  fptiOptions: PropTypes.shape(FPTI_OBJECT).isRequired,
  spinnerType: PropTypes.oneOf([spinnerTypes.SHIMMER, spinnerTypes.LOADER]),
  spinnerSize: PropTypes.oneOf([sizes.SMALL, sizes.MEDIUM, sizes.LARGE]),
  componentName: PropTypes.string.isRequired,
  version: PropTypes.string,
  customLoaderStyle: PropTypes.string,
  devMode: PropTypes.bool,
  devData: PropTypes.shape({})
};

// currency converter default props
HcCurrencyConv.defaultProps = {
  suppressError: true,
  spinnerType: spinnerTypes.SHIMMER,
  spinnerSize: sizes.LARGE,
  version: 'v1',
  devMode: false
};

export { HcCurrencyConv };
